import { useCreateShippingLocationGroupMutation } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import Action from '@/gf/components/Action'
import CloseModalButton from '@/gf/components/CloseModalButton'
import Modal from '@/gf/components/ModalNext'
import Field from '@/gf/components/next/forms/Field'
import TextInput from '@/gf/components/next/forms/TextInput'
import useMsgs from '@/gf/hooks/useMsgs'
import { ApolloError } from '@apollo/client'
import { useState } from 'react'

const CreateLocationGroupModal = ({
  orgId,
  onClose,
  onSuccess,
}: {
  orgId: string
  onClose: () => void
  onSuccess: () => void
}) => {
  const client = useGqlClient()
  const [_, msgr] = useMsgs()
  const [createGroup] = useCreateShippingLocationGroupMutation({ client })
  const [name, setName] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!name.trim()) {
      msgr.add('Please enter a location group name', 'negative')
      return
    }

    setIsSubmitting(true)

    try {
      await createGroup({
        variables: {
          name: name.trim(),
          orgId,
        },
      })

      onSuccess()
    } catch (err) {
      const error = err as ApolloError
      const message = error.graphQLErrors.reduce((acc, error) => `${acc}${error.message}`, '')
      msgr.add(message || 'Failed to create location group', 'negative')
      setIsSubmitting(false)
    }
  }

  return (
    <Modal onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-900">Create Location Group</h3>
            <CloseModalButton onClick={onClose} />
          </div>

          <Field label="Name" htmlFor="groupName">
            <TextInput
              id="groupName"
              value={name}
              setValue={setName}
              placeholder="e.g., North Region, Shop A, etc."
              autoFocus
              required
            />
          </Field>

          <div className="mt-6 flex justify-end gap-3">
            <Action.S onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Action.S>
            <Action.P color="blue" type="submit" performing={isSubmitting} disabled={isSubmitting}>
              Create
            </Action.P>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default CreateLocationGroupModal
